// The index is kept alongside each entry because removing an uploaded file
// falls back to it when the backend did not return a file id.
export const getUploadedFiles = (results = []) =>
  results
    .map((result, uploadResultIndex) => ({ ...result, uploadResultIndex }))
    .filter((result) => result.filename);

export const hasUploadedFiles = (results = []) =>
  results.some((result) => Boolean(result?.filename) && !result.error);

export const sumFileRecordCount = (results = []) =>
  results.reduce((total, result) => {
    if (result?.error) {
      return total;
    }
    return total + (result?.record_count ?? 0);
  }, 0);
